/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listCopy} from '../api'

export const useMutationListCopy = createReactQueryMutationHook('listCopy', listCopy)
